import React, { Fragment, useContext } from "react";
import SelectableTable from "components/DesignSystem/SelectableTable";
import { Link, useHistory, useLocation } from "react-router-dom";
import { packClasses } from "Utils";
import { EntryListContext } from ".";
import { range } from "lodash";
import EmptyState from "components/DesignSystem/EmptyState";

export default function EntryTable(props) {
    const { items, selectedItems, loading } = useContext(EntryListContext);
    const history = useHistory();
    const location = useLocation();

    const selectAll = (e) => {
        if (e.target.checked) {
            props.setAllSelected(items.map((item) => item.uuid));
        } else {
            props.setAllSelected([]);
        }
    };

    const updateParams = (key, val = null) => {
        const params = new URLSearchParams(location.search);

        if (typeof key === "object") {
            Object.entries(key).forEach(([k, v]) => {
                params.set(k, v);
            });
        } else {
            if (params.has(key) && params.get(key) === val) {
                params.delete(key);
            } else {
                params.set(key, val);
            }
        }

        history.replace(location.pathname + "?" + params.toString());
    };

    const onSort = (sortKey) => {
        let sortDir = "desc";
        if (
            props.queryParams.has("order") &&
            props.queryParams.get("order") === sortKey
        ) {
            if (
                props.queryParams.has("dir") &&
                props.queryParams.get("dir") === "asc"
            ) {
                sortDir = "desc";
            } else {
                sortDir = "asc";
            }
        }

        updateParams({ order: sortKey, dir: sortDir });
    };

    return (
        <SelectableTable total={items.length} selected={selectedItems.length}>
            {({ innerRef }) => (
                <Fragment>
                    <thead className="bg-gray-50 ">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <input
                                    type="checkbox"
                                    className="appearance-none rounded text-green-700 focus:ring-green-700"
                                    ref={innerRef}
                                    onChange={(e) => selectAll(e)}
                                />
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        !props.queryParams.has("order") ||
                                            props.queryParams.get("order") ===
                                                "title"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("title")}
                                >
                                    Title
                                </button>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        props.queryParams.has("order") &&
                                            props.queryParams.get("order") ===
                                                "slug"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("slug")}
                                >
                                    Slug
                                </button>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        props.queryParams.has("order") &&
                                            props.queryParams.get("order") ===
                                                "channel_id"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("channel_id")}
                                >
                                    Channel
                                </button>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        props.queryParams.has("order") &&
                                            props.queryParams.get("order") ===
                                                "modified_at"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("modified_at")}
                                >
                                    Last Modified
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                        {!loading && items.length === 0 && (
                            <tr>
                                <td colSpan={5}>
                                    <EmptyState />
                                </td>
                            </tr>
                        )}
                        {loading
                            ? range(0, 10).map((i) => (
                                  <tr className="animate-pulse" key={i}>
                                      <td
                                          className="whitespace-nowrap px-4 py-2"
                                          colSpan={5}
                                      >
                                          <div className="my-1 h-5 rounded bg-gray-300 leading-none">
                                              &nbsp;
                                          </div>
                                      </td>
                                  </tr>
                              ))
                            : items.map((item) => (
                                  <tr key={item.id}>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <input
                                              className="appearance-none rounded text-green-700 focus:ring-green-700"
                                              type="checkbox"
                                              onChange={(e) => {
                                                  props.addSelected(
                                                      e,
                                                      item.uuid
                                                  );
                                              }}
                                              checked={selectedItems.find(
                                                  (id) => id === item.uuid
                                              )}
                                          />
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <Link
                                              to={`/app/custom-content/entry/${item.uuid}`}
                                              className="color-gray-800 hover:underline"
                                          >
                                              {item.title}
                                          </Link>
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <Link
                                              to={`/app/custom-content/entry/${item.uuid}`}
                                              className="color-gray-600 text-sm hover:underline"
                                          >
                                              {item.slug}
                                          </Link>
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <Link
                                              to={
                                                  "/app/custom-content/channel/" +
                                                  item.channel?.uuid
                                              }
                                              className="color-gray-600 text-sm hover:underline"
                                          >
                                              {item.channel?.title ||
                                                  "No Channel!"}
                                          </Link>
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <span className="color-gray-600 text-sm">
                                              {item?.modified_at?.toFormat(
                                                  "ff"
                                              )}
                                          </span>
                                      </td>
                                  </tr>
                              ))}
                    </tbody>
                </Fragment>
            )}
        </SelectableTable>
    );
}
